module.exports = __webpack_public_path__ + "static/media/tiktok.ebf794d0.png";